import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartestatusComponent } from './cartestatus.component';
import { ChangestatusComponent } from './changestatus/changestatus.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';

@NgModule({
  declarations: [CartestatusComponent, ChangestatusComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    MaterialModule,
    BreadcrumbsModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
    FurySharedModule
  ],
  entryComponents: [ChangestatusComponent]
})
export class CartestatusModule { }
